/**
 * RO-7-04 / #44334 — shared Operation schemas for task twins.
 *
 * Consumed by contracts/tasks.ts and tools/tasks.ts so task_list and
 * tasks.list cannot drift on status/priority enums or list filter bounds.
 */
import { z } from "zod";
export const TASK_STATUS = [
    "backlog",
    "todo",
    "in_progress",
    "review",
    "done",
    "cancelled",
];
export const taskStatusSchema = z.enum(TASK_STATUS);
export const TASK_PRIORITY = ["low", "medium", "high", "urgent"];
export const taskPrioritySchema = z.enum(TASK_PRIORITY);
/**
 * SQL ORDER BY fragment shared by tasks.list (listScopedTasksPaginated) and
 * task_list multi-row results so identity sets at a given limit agree.
 */
export const TASK_STATUS_ORDER_SQL = `CASE t.status
  WHEN 'in_progress' THEN 0
  WHEN 'review'      THEN 1
  WHEN 'todo'        THEN 2
  WHEN 'backlog'     THEN 3
  WHEN 'done'        THEN 4
  WHEN 'cancelled'   THEN 5
  ELSE 6 END`;
/**
 * List filters common to tasks.list (HTTP) and task_list (MCP).
 * HTTP adds page/page_size/section_id via contracts; MCP adds id/project slug
 * resolver fields and description-on-by-id behavior in the tool handler.
 */
export const tasksListFiltersSchema = z.object({
    project_id: z.coerce.number().int().optional(),
    section_id: z.coerce.number().int().optional(),
    status: taskStatusSchema.optional(),
    /** Substring search on title (HTTP `q`, MCP `search`). */
    q: z.string().optional(),
    page: z.coerce.number().int().min(1).optional(),
    page_size: z.coerce.number().int().min(1).max(200).optional(),
});
